"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Cookie_1 = require("./Cookie");
var CookieType;
(function (CookieType) {
    CookieType["NECESSARY"] = "necessary";
    CookieType["FUNCTIONAL"] = "functional";
    CookieType["PERFORMANCE"] = "performance";
    CookieType["MARKETING"] = "marketing";
})(CookieType = exports.CookieType || (exports.CookieType = {}));
var CookieOptions;
(function (CookieOptions) {
    CookieOptions["ALLOW"] = "allow";
    CookieOptions["DENY"] = "deny";
})(CookieOptions = exports.CookieOptions || (exports.CookieOptions = {}));
exports.CONFIG_EXPIRATION = 365 * 24 * 60 * 60 * 1000;
var CKies = /** @class */ (function () {
    function CKies() {
    }
    // Get expiration date for new cookies
    CKies.getExpireDate = function () {
        var date = new Date();
        date.setTime(date.getTime() + exports.CONFIG_EXPIRATION);
        return date;
    };
    // Get cookie name for CookieType
    CKies.key = function (type) {
        return "ckies_" + type;
    };
    // Check if CookieType should be used
    CKies.use = function (type) {
        if (type === CookieType.NECESSARY) {
            return true;
        }
        return this.isOptIn() ? (Cookie_1.Cookie.get(this.key(type)) === CookieOptions.ALLOW) : (Cookie_1.Cookie.get(this.key(type)) !== CookieOptions.DENY);
    };
    // Deny usage for CookieType
    CKies.deny = function (type) {
        this.set(type, CookieOptions.DENY);
    };
    // Allow usage for CookieType
    CKies.allow = function (type) {
        this.set(type, CookieOptions.ALLOW);
    };
    // Wrapper to check if necesserary cookies can be used
    CKies.useNecessary = function () {
        return this.use(CookieType.NECESSARY);
    };
    // Wrapper to check if functional cookies can be used
    CKies.useFunctional = function () {
        return this.use(CookieType.FUNCTIONAL);
    };
    // Wrapper to check if performance cookies can be used
    CKies.usePerformance = function () {
        return this.use(CookieType.PERFORMANCE);
    };
    // Wrapper to check if marketing cookies can be used
    CKies.useMarketing = function () {
        return this.use(CookieType.MARKETING);
    };
    // Set cookie for CookieType
    CKies.set = function (type, option) {
        if (type !== CookieType.NECESSARY) {
            Cookie_1.Cookie.set(this.key(type), option, this.getExpireDate());
        }
    };
    // Check if mode is OPT_IN
    CKies.isOptIn = function () {
        /* tslint:disable */
        return window.hasOwnProperty('CKIES_OPTIN') && window['CKIES_OPTIN'] === true;
        /* tslint:enable */
    };
    return CKies;
}());
exports.CKies = CKies;
//# sourceMappingURL=CKies.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ckies/library/dist/lib/CKies.js
// module id = 921
// module chunks = 193 194 199